import { wireStateFromStatus } from '@bt-common/services/message-status';

interface LogLike { messageId?: string; status?: string; }
interface MsgLike { _id?: string; }

/**
 * The messageIds a campaign's live message-logs report as having LEFT the queue —
 * i.e. reached the wire (sent / confirmed / delivered / read). Still-queued and
 * failed logs are excluded on purpose: a failed message keeps a (non-deleted)
 * user-message and must stay retryable in the "waiting to be sent" list.
 */
export function sentMessageIdsFromLogs(logs: LogLike[]): Set<string> {
  const ids = new Set<string>();
  for (const log of logs) {
    if (log.messageId && log.status && wireStateFromStatus(log.status) === 'sent') {
      ids.add(log.messageId);
    }
  }
  return ids;
}

/**
 * Drop user-messages a live message-log already reports as sent. On send the
 * backend DELETES the user-message and creates a message-log, but that deletion
 * does not always reach this client live — only a full refresh rebuilds the
 * store (getPendingUserMessages). The message-log CREATE does arrive live (it is
 * what updates the "Sent" tab), so reconciling the waiting list against it keeps
 * the two tabs in lockstep without a refresh.
 */
export function excludeSentFromWaiting<T extends MsgLike>(dbMessages: T[], sentIds: Set<string>): T[] {
  if (sentIds.size === 0) return dbMessages;
  return dbMessages.filter(m => !m._id || !sentIds.has(m._id));
}
